const ACTIVE_BRANCH_KEY = 'fitnet.activeBranchId.v2';
// v1 values were rounded through Number() and can name a branch that never existed. The
// corrupted id is indistinguishable from a real one, so the whole key is retired instead.
const LEGACY_ACTIVE_BRANCH_KEY = 'fitnet.activeBranchId';

// Runs at module scope, so it must survive an environment without a DOM (unit tests)
// and a browser that blocks storage (private mode).
const getStorage = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch (err) {
    return null;
  }
};

// Kept as a string: branch ids are 18 digits and exceed Number.MAX_SAFE_INTEGER, so
// Number() rounds them to a neighbouring branch that does not exist.
const readStoredBranch = () => {
  const storage = getStorage();
  if (!storage) return null;
  storage.removeItem(LEGACY_ACTIVE_BRANCH_KEY);
  return storage.getItem(ACTIVE_BRANCH_KEY) || null;
};

export default {
  state: {
    userData: undefined,
    ipAddress: undefined,
    requiresChangePasswordOnLogin: false,

    // Logged in user permissions
    userAuthActions: [],

    // Permission change tracking lists
    addAuthActionLst: [],
    deleteAuthActionLst: [],

    // Active branch sent as X-Branch-Id, and the caller's resolved branch access (from
    // GET /Branch/MyAccess). Persisted so the selection survives a reload.
    activeBranchId: readStoredBranch(),
    branchAccess: { canAccessAllBranches: false, accessibleBranchIds: [] },
  },

  mutations: {
    changeUserData(state, payload) {
      state.userData = payload;
    },
    changeActiveBranch(state, payload) {
      state.activeBranchId = payload || null;
      const storage = getStorage();
      if (!storage) return;
      if (payload) {
        storage.setItem(ACTIVE_BRANCH_KEY, String(payload));
      } else {
        storage.removeItem(ACTIVE_BRANCH_KEY);
      }
    },
    changeBranchAccess(state, payload) {
      state.branchAccess = payload || { canAccessAllBranches: false, accessibleBranchIds: [] };
    },
    changeIPAddress(state, payload) {
      state.ipAddress = payload;
    },
    changeRequiresChangePasswordOnLogin(state, payload) {
      state.requiresChangePasswordOnLogin = payload;
    },
    changeUserAuthActions(state, payload) {
      state.userAuthActions = payload;
    },
    clearAuthActionLst(state) {
      state.addAuthActionLst = [];
      state.deleteAuthActionLst = [];
    },
    addItemToAddAuthActionLst(state, payload) {
      state.addAuthActionLst.push(payload);
    },
    addItemToDeleteAuthActionLst(state, payload) {
      state.deleteAuthActionLst.push(payload);
    },
    removeItemFromAddAuthActionLst(state, payload) {
      state.addAuthActionLst = state.addAuthActionLst.filter((i) => i !== payload);
    },
    removeItemFromDeleteAuthActionLst(state, payload) {
      state.deleteAuthActionLst = state.deleteAuthActionLst.filter((i) => i !== payload);
    },
  },
};
